export default {
    props: {
        error: {
            default: false,
        },
        errorIndex: {
            default: false,
        },
        errorQuiet: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        hasError() {
            return this.getCurrentError() !== false
        },
        isSimpleError() {
            return this.getCurrentError().length == 1
        },
        getChoiceError() {
            let splitted = this.getCurrentError()

            return {
                error: splitted[0],
                count: isNaN(splitted[1]) ? this.$t('validator.fields.' + splitted[1]) : parseInt(splitted[1]),
            }
        },
        getCurrentError() {
            let error = this.error

            if (!error) {
                return false
            }

            if (this.errorIndex !== false) {
                let byIndex = error.filter(item => {
                    return item.indexOf('-' + this.errorIndex) != -1
                })

                if (!byIndex.length) {
                    return false
                }

                error = byIndex[0].split('-' + this.errorIndex)[0]
            }

            return error.split(':')
        },
    },
}
